import { BiTachometer } from 'react-icons/bi';
import { Resources } from '../resource';
import {MainPage} from './main-page';

export const name = Resources.dashboardV3;

export const list = MainPage;

export const icon = BiTachometer;

export const options = { label: 'resource.dashboard-v3' };
